import { Typography } from "antd";
import React from "react";
import { match, P } from "ts-pattern";
import { TenantType, UsageType } from "../../../../../types/bookings";
import { CompanyTenantDetailsFields } from "./commercial/CompanyTenantDetailsFields";
import { IndividualTenantDetailsFields } from "./commercial/IndividualTenantDetailsFields";
import { ResidentialTenantDetailsFields } from "./residential/ResidentialTenantDetailsFields";

type TenantDetailFormProps = {
  usageType: UsageType;
  tenantType: TenantType;
};
export const TenantDetailForm = (props: TenantDetailFormProps) => {
  const { usageType, tenantType } = props;

  const renderTenantDetailsFields = () =>
    match<[UsageType, TenantType]>([usageType, tenantType])
      .with(["residential", P._], () => <ResidentialTenantDetailsFields />)
      .with(["commercial", "company"], () => <CompanyTenantDetailsFields />)
      .with(["commercial", "individual"], () => <IndividualTenantDetailsFields />)
      .exhaustive();

  return (
    <>
      <Typography.Paragraph className="m-10 smallFont13 fp-para-line">
        Enter an email address to look for an existing tenant or add a new one.
      </Typography.Paragraph>

      {renderTenantDetailsFields()}
    </>
  );
};
